import EditableTable from 'components/common/EditableTable'
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useLocation } from 'react-router-dom';
import { fetchVerifiedInvoices } from 'slices/invoiceSlice';
import { verifyInvoice } from 'slices/invoiceSlice';
import { fetchAppointClients } from 'slices/invoiceSlice';
import { updateInvoice } from 'slices/invoiceSlice';
import { invoicesSelector } from 'slices/invoiceSlice';
import { fetchUnVerifiedInvoices } from 'slices/invoiceSlice';

const InvoiceAppointmentDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const refAddutton = React.useRef(null);
    const { checkPermission } = usePermissions();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { appointClients, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(invoicesSelector);
    const [searchTerm, setSearchTerm] = React.useState("");

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get("start_date");
    const endDate = queryParams.get("end_date");
    const invoicingPeriod = queryParams.get("invoicing_period");

    React.useEffect(() => {
        // dispatch(fetchAppointClients(1, { client_ids: id }))
        const filters = {
            client_ids: id,
            ...(startDate && { start_date: startDate }),
            ...(endDate && { end_date: endDate }),
            ...(invoicingPeriod && { invoicing_period: invoicingPeriod }),
        };

        dispatch(fetchAppointClients(1, filters));
    }, [])

    const data = appointClients?.find(t => t.id === Number(id));

    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchAppointClients(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }
        return (
            <tr>
                <th>
                    <div className="row_check">
                        <span>Prog. #</span>
                    </div>
                </th>
                <th >
                    <TableHeaderItem
                        title="Appointment Number"
                        sortBy="appt_no"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Date & Time"
                        sortBy="datetime"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Start Time"
                        sortBy="start_time"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="End Time"
                        sortBy="end_time"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total Hours"
                        sortBy="total_hours"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Rate"
                        sortBy="rate"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total"
                        sortBy="total"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Facility"
                        sortBy="facility"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Requestor"
                        sortBy="requestor"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Interpreter Name"
                        sortBy="interpreter_name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Notes"
                        sortBy="notes"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [searchTerm, sortConfig, currentPage]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.appointments?.map((item, index) => (
                <AppointClientItems data={item} index={index} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [appointClients]);

    //#endregion


    return (
        <>
        {data?.appointments?.length > 0 && (
        <ListLayout
            time={false}
            // haveBackBtn={true}
            heading={`Interpretation - ${data?.user?.name || ''}`}
            addButtonDisabled={true}
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            hideRemoveButton={true}
            invoiceButton={true}
            totalPages={totalPages}
            fetchList={fetchAppointClients}
            refAddutton={refAddutton}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            loader={loader}
            noOfItems={total}
            searchPlaceholder="Search..."
        >
        </ListLayout>
    )
}
        {data?.special_project?.length > 0 && (
        <SpecialProjectList data={data?.special_project || []} clientName={data?.user?.name || ''} />
        )}
        </>
    )
}

const SpecialProjectList = ({ data, clientName }) => {
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'id',
        sortDirection: 'desc',
    });
    const pageLength = 10;

    const filteredProjects = React.useMemo(() => {
        const search = searchTerm.trim().toLowerCase();
        if (!search) return data;

        return data.filter((project) => {
            const values = [
                project?.translation?.transid,
                project?.translation?.created_at,
                project?.translation?.status,
                project?.amount,
            ];
            return values.some((value) => String(value ?? '').toLowerCase().includes(search));
        });
    }, [data, searchTerm]);

    const sortedProjects = React.useMemo(() => {
        return [...filteredProjects].sort((first, second) => {
            const getValue = (project) => {
                if (sortConfig.sortBy === 'date') return project?.translation?.created_at || '';
                if (sortConfig.sortBy === 'status') return project?.translation?.status || '';
                if (sortConfig.sortBy === 'amount') return Number(project?.amount || 0);
                return project?.translation?.transid || '';
            };

            const firstValue = getValue(first);
            const secondValue = getValue(second);
            const comparison = typeof firstValue === 'number' && typeof secondValue === 'number'
                ? firstValue - secondValue
                : String(firstValue).localeCompare(String(secondValue));

            return sortConfig.sortDirection === 'asc' ? comparison : -comparison;
        });
    }, [filteredProjects, sortConfig]);

    const totalPages = Math.max(1, Math.ceil(sortedProjects.length / pageLength));
    const visibleProjects = sortedProjects.slice(
        (currentPage - 1) * pageLength,
        currentPage * pageLength
    );

    React.useEffect(() => {
        if (currentPage > totalPages) setCurrentPage(totalPages);
    }, [currentPage, totalPages]);

    const fetchLocalProjects = (page, params = {}) => () => {
        setCurrentPage(page);
        if (typeof params.search === 'string') setSearchTerm(params.search);
    };

    const handleSort = (direction, sortBy) => {
        setSortConfig({ sortBy, sortDirection: direction });
        setCurrentPage(1);
    };

    const renderTableHeader = React.useCallback(() => (
        <tr>
            <th>#</th>
            <th>
                <TableHeaderItem
                    title="Project Number"
                    sortBy="project"
                    sortDirection={sortConfig.sortDirection}
                    callBack={handleSort}
                />
            </th>
            <th>
                <TableHeaderItem
                    title="Date"
                    sortBy="date"
                    sortDirection={sortConfig.sortDirection}
                    callBack={handleSort}
                />
            </th>
            <th>
                <TableHeaderItem
                    title="Amount"
                    sortBy="amount"
                    sortDirection={sortConfig.sortDirection}
                    callBack={handleSort}
                />
            </th>
            <th>
                <TableHeaderItem
                    title="Source Language"
                    sortBy="source_language"
                    sortDirection={sortConfig.sortDirection}
                    callBack={handleSort}
                />
            </th>
            <th>
                <TableHeaderItem
                    title="Target Language"
                    sortBy="target_language"
                    sortDirection={sortConfig.sortDirection}
                    callBack={handleSort}
                />
            </th>
            <th>
                <TableHeaderItem
                    title="Status"
                    sortBy="status"
                    sortDirection={sortConfig.sortDirection}
                    callBack={handleSort}
                />
            </th>
        </tr>
    ), [sortConfig]);

    const renderTableContent = React.useCallback(() => (
        visibleProjects.map((project, index) => (
            <SpecialProjectItem
                key={project?.id || index}
                project={project}
                index={index + (currentPage - 1) * pageLength}
            />
        ))
    ), [visibleProjects, currentPage]);

    return (
        <ListLayout
            heading={`Special Project - ${clientName}`}
            time={false}
            addButtonDisabled={true}
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            fetchList={fetchLocalProjects}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            searchPlaceholder="Search in special projects ..."
            totalPages={totalPages}
            noOfItems={sortedProjects.length}
            sortConfig={sortConfig}
            defaultPageLength={pageLength}
            hideRemoveButton={true}
            invoiceButton={true}
        />
    );
};

const SpecialProjectItem = ({ project, index }) => {
    const { checkPermission } = usePermissions();
    const projectNumber = project?.translation?.transid || 'N/A';
    const projectLink = `/translation/view/${project?.translation?.id}`;

    return (
        <tr>
            <td>{index + 1}</td>
            <td>
                {checkPermission('Detail Appointments') && project?.translation?.id ? (
                    <Link className="link_preview" to={projectLink}>
                        {projectNumber}
                    </Link>
                ) : projectNumber}
            </td>
            <td>
                {project?.translation?.created_at
                    ? moment(project.translation.created_at).format('DD/MM/YYYY')
                    : 'N/A'}
            </td>
            <td>${Number(project?.amount || 0).toFixed(2)}</td>
            <td>{project?.translation?.language?.name || ''}</td>
            <td>{project?.translation?.translation_target_languages ?.map(item => item?.language?.name).join(', ') || ''}</td>
            <td className="text-capitalize">
                {project?.translation?.status || 'N/A'}
            </td>
        </tr>
    );
};

const AppointClientItems = ({
    data, index, current_page, pageLength, checkPermission
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                </div>
            </td>
            <td>
                {checkPermission('Detail Appointments') ?
                    <Link className='link_preview' to={`/appointments/view/${data?.id}`}>
                        {data?.appid || "N/A"}
                    </Link>
                    :
                    data?.appid || "N/A"
                }
            </td>
            <td>
                {data.datetime || "N/A"}
            </td>
            <td>
                {data?.appointment_assign?.checkin_time || "N/A"}
            </td>
            <td>
                {data?.appointment_assign?.checkout_time || "N/A"}
            </td>
            <td>
                {data?.invoice?.total_hours || "N/A"}
            </td>
            <td>
                ${(data?.invoice?.rate && data?.invoice?.rate_unit)
                    ? (data.invoice.rate +'/'+ data.invoice.rate_unit)
                    : 0}
            </td>
            <td>
                ${data.invoice?.total_amount ? parseFloat(data.invoice?.total_amount)?.toFixed(2) : 0.00}
            </td>
            <td>
                {data?.appointment_details?.facility?.facility_name || data?.appointment_details?.address || 'N/A'}
            </td>
            <td>
                {data?.appointment_details?.requester_name}
            </td>
            <td>
                {data.language?.name}
            </td>
            <td>
                {data?.interpreter?.first_name ? (data?.interpreter?.first_name + " " + data?.interpreter?.last_name) : 'N/A'}
            </td>
            <td>
                {data?.invoice?.notes || "N/A"}
            </td>
            <td className='text-capitalize'>
                {data?.status || "N/A"}
            </td>
        </tr>
    )
}


export default InvoiceAppointmentDetail